export default "__VITE_ASSET__DWtH74hk__"